import React, { useCallback, useEffect, useMemo, useState } from 'react';

import PropTypes from 'prop-types';
import { toast } from 'sonner';
import Honeybadger from '@honeybadger-io/js';

import { deserializer } from '../../../../../shared/utils/deserializer';
import { fetchTags as apiFetchTags } from '../../../../shared/services';
import { clearFilterByType, toggleFilterValue } from '../../../../shared/utils';
import ClientFilterContext from './ClientFilterContext';

const INITIAL_ACTIVE_FILTERS = {
  tags: [],
};

const INITIAL_FILTER_OPTIONS = {
  tags: [],
};

const ClientFilterProvider = ({ children }) => {
  const [activeFilters, setActiveFilters] = useState(INITIAL_ACTIVE_FILTERS);
  const [filterOptions, setFilterOptions] = useState(INITIAL_FILTER_OPTIONS);

  const clearFilters = useCallback((type) => {
    setActiveFilters((prev) => clearFilterByType(prev, type));
  }, []);

  const toggleFilter = useCallback(({ type, value }) => {
    setActiveFilters((prev) => toggleFilterValue(prev, { type, value }));
  }, []);

  useEffect(() => {
    const fetchFilterOptions = async () => {
      try {
        const tagsResponse = await apiFetchTags('Client');
        const tags = await deserializer.deserialize(tagsResponse);

        setFilterOptions({ tags });
      } catch (error) {
        toast.error(error.message);
        Honeybadger.notify(error);
      }
    };

    fetchFilterOptions();
  }, []);

  const contextValue = useMemo(
    () => ({
      activeFilters,
      clearFilters,
      filterOptions,
      toggleFilter,
    }),
    [activeFilters, clearFilters, filterOptions, toggleFilter]
  );

  return (
    <ClientFilterContext.Provider value={contextValue}>
      {children}
    </ClientFilterContext.Provider>
  );
};

ClientFilterProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ClientFilterProvider;
